<template>
  <div class="button-box">
    <el-button 
      v-for="(item,index) in buttonList" 
      v-if="!disabledButtons.includes(item.onclick)"
      :key="index" 
      :type="item.type" 
      plain 
      size="mini" 
      @click.stop="handleClick(item.onclick)"
    >
      {{item.value}}
    </el-button>
  </div>
</template>
<script>
export default {
  name: "PermissionMethodRow",
  props: {
    url: {
      type: String
    },
    id: {
      type: String,
      default: ""
    },
    disabledButtons: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      buttonData: '',
      buttonList: []
    }
  },
  created () {
    this.createButtonList();
  },
  watch: {
    disabledButtons: {
      handler () {
        this.updateButtonDisabledState();
      },
      deep: true
    }
  },
  methods: {
    getQueryString (name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var search = decodeURIComponent(this.url);
      var index = search.indexOf("?");
      var r = search.substr(index + 1).match(reg);
      if (r != null) return unescape(r[2]); return null;
    },
    createButtonList () {
      this.buttonData = this.getQueryString("buttonData");
      var array = this.buttonData.split(",");
      for (let i = 0; i < array.length; i++) {
        const element = array[i];
        var buttons = element.split(":");
        if (buttons.length >= 5) {
          if (buttons[4] != this.id) {
            continue;
          }
          var button = {
            value: buttons[0],
            onclick: buttons[1],
            alt: buttons[2],
            type: buttons[3],
            disabled: this.disabledButtons.includes(buttons[1])
          };
          this.buttonList.push(button);
        }
      }
    },
    updateButtonDisabledState () {
      // 更新按钮的禁用状态
      this.buttonList.forEach(button => {
        button.disabled = this.disabledButtons.includes(button.onclick);
      });
    },
    handleClick (onclick) {
      // 检查按钮是否被禁用
      const button = this.buttonList.find(btn => btn.onclick === onclick);
      if (button && button.disabled) {
        return;
      }
      this.$emit(onclick);
    }
  }
};
</script>
<style scoped>
.button-box {
  padding: 2px;
    display: flex;
}
</style>
